export default {
  tooltip_title: 'Kliknij, aby skopiować',
  success: 'Skopiowano!',
};
